import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, AppBar, Toolbar, Button, Divider } from '@mui/material';
import TranslatedText from '../components/TranslatedText';
import LanguageSelector from '../components/LanguageSelector';
import { useLanguage } from '../context/LanguageContext';

const LegalPage = () => {
  const { language } = useLanguage();

  return (
    <Box>
      {/* Header */}
      <AppBar position="fixed" sx={{ bgcolor: 'rgb(25, 118, 210)' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Toolbar>
            <Typography variant="h6" component={Link} to="/" sx={{ flexGrow: 1, color: 'white', textDecoration: 'none' }}>
              Unpen
            </Typography>
            <LanguageSelector />
            <Button color="inherit" component={Link} to="/login">
              <TranslatedText textId="signin" />
            </Button>
          </Toolbar>
        </Box>
      </AppBar>
      
      {/* Main Content */}
      <Container maxWidth="md" sx={{ pt: 10, pb: 6, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          <TranslatedText textId="legalMention" />
        </Typography>
        
        <Box sx={{ my: 6 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            <TranslatedText textId="editor" />
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body1">
            Unpen SARL • <TranslatedText textId="capital" /> 400,00 € <br />
            9 rue paul giroud<br />
            90000 Belfort, France<br />
            unpen.io@gmail.com<br />
            987 749 181 R.C.S. Belfort<br />
            SIRET n° 987 749 181<br />
          </Typography>
        </Box>
        
        <Box sx={{ my: 6 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            <TranslatedText textId="Hosting" />
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body1">
            OVH<br />
            2 rue Kellermann<br />
            BP 80157<br />
            59053 ROUBAIX<br />
            CEDEX 1<br />
            08 203 203 63 (0,118 € / min)
          </Typography>
        </Box>
        
        <Box sx={{ my: 4, display: 'flex', justifyContent: 'center', gap: 3 }}>
          <Link to={`/${language === 'en' ? '' : language}/tos`} style={{ textDecoration: 'none' }}>
            <Button variant="outlined">
              <TranslatedText textId="TOS" />
            </Button>
          </Link>
          <Link to="#" style={{ textDecoration: 'none' }}>
            <Button variant="outlined">CGV</Button>
          </Link>
        </Box>
      </Container>
      
      {/* Footer */}
      <Box component="footer" sx={{ bgcolor: 'rgb(25, 118, 210)', py: 3, textAlign: 'center' }}>
        <Link to={`/${language === 'en' ? '' : language}`} style={{ color: 'white', margin: '0 25px' }}>
          <TranslatedText textId="features" />
        </Link>
        <Link to={`/${language === 'en' ? '' : language}/tos`} style={{ color: 'white', margin: '0 25px' }}>
          <TranslatedText textId="TOS" />
        </Link>
      </Box>
    </Box>
  );
};

export default LegalPage; 